import i18n from '@/plugins';

const state = {
  messages: {},
  locale: null,
};

const mutations = {
  ADD_MESSAGES(state, payload) {
    state.messages[payload.locale] = payload.messages;
    i18n.setLocaleMessage(payload.locale, payload.messages);
  },

  SET_LOCALE(state, locale) {
    state.locale = locale;
    i18n.locale = locale;
  }
};

const actions = {};

const getters = {
  locale: state => state.locale,
  messagesLocale: state => locale => state.messages[locale],
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
